import { CommonMessages } from 'appAssets/messages/common.messages';

export const PanelSettingsProductsEditDetailsMessages = {
    GetProductFailed: {
        key: 'GetProductFailed',
        message: 'Error while communication with the server. Can\'t get available product.'
    },
    GetProductNoData: {
        key: 'GetProductNoData',
        message: 'Can\'t find product.'
    },
    ...CommonMessages
};
